// extracted by mini-css-extract-plugin
export default {"gallery":"ZUsiB","slide":"rz2ct","navigationLink":"yFSUS","active":"ToHGy","arrowTriple":"N74Af"};